import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {SearchAction} from "../actions/SearchAction"
import i18n from "i18next"
import {Button, message, Modal} from "antd";
import SearchCard from "./SearchCard";
import PdfDownloadLink from "./PdfDownloadLink";
import ReportService from "../services/report.service";
import {gaEventWithUserIdLabel, LOG_OUT, SEARCH_SUCCESS} from "../constants";
import AuthService from "../services/auth.service";

class SearchCardModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false,
            searcher: "",
            searchDate: ""
        }
    }

    searchDetail = (itemId, searchType, event) => {
        ReportService.searchDetail(itemId)
            .then(
                response => {

                    if (response.data.success === true) {
                        const {items} = response.data;

                        let searchResults = items ? items : [];

                        if (items) {

                            const searchResultPayload = {
                                searchResults: searchResults,
                                includeAdverseMedia: false,
                                additionalMediaLinks: []
                            }

                            this.props.searchAction(SEARCH_SUCCESS, searchResultPayload)

                            let searcher = response.data.searcher
                            let searchDate = response.data.searchDate

                            this.setState({
                                modalVisible: true,
                                searcher: searcher,
                                searchDate: searchDate
                            })
                        }
                    } else {
                        if (response.data.error && response.data.error !== "") {
                            message.error(response.data.error)
                        } else {
                            message.error(i18n.t('global_error'))
                        }
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ReportService.searchDetail Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )

        event.preventDefault()
    }

    onCancel = () => {
        this.setState({modalVisible: false})
    }

    render() {

        const {modalVisible, searcher, searchDate} = this.state

        const {itemId, danger, text, searchType, searchId} = this.props

        let bType = "primary";
        if (danger) bType = "danger"

        return (
            <>
                <Button
                    className=""
                    type={bType}
                    onClick={event => {
                        this.searchDetail(itemId, searchType, event)
                    }}
                >
                    {text}
                </Button>

                <Modal
                    title={
                        <div className="row justify-content-between report-search-result-modal-title">
                            <div className="col-12 col-sm-6">
                                <ul>
                                    <li>
                                        {i18n.t('searcherUser') + searcher}
                                    </li>
                                    <li>{i18n.t('searchDate') + searchDate}</li>
                                </ul>
                            </div>
                            <div className="col-12 col-sm-6 margin-auto text-sm-center">
                                <PdfDownloadLink itemId={itemId} searchId={searchId}/>
                            </div>
                        </div>
                    }
                    className="report-search-result-modal"
                    visible={modalVisible}
                    onCancel={this.onCancel}
                    width={"98%"}
                    footer={null}
                    centered
                >
                    <SearchCard/>
                </Modal>
            </>
        )
    }

}

function mapStateToProps(state) {

    return {
        common: state.common,
        user: state.user,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchCardModal);